import { Box, Grid } from '@material-ui/core'
import { func, number } from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const Body = styled.div`
  padding: 2em 0em;
`
const Line = styled.div`
  border-bottom: 3px solid var(--second);
`
const GridItem = styled(Grid)`
  cursor: pointer;
  padding: 2em 0em;
  box-sizing: border-box;
  border-top: ${props => props.$selected ? '5px solid var(--second)' : '5px solid #fff'};
  display: flex;
  align-items: flex-start;
  align-items: center;
  @media screen and (max-width:960px) {
    border-top: none;
    padding: .5em 0em;
  }
`

const Number = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2em;
  color: #fff;
  background-color: ${props => props.$selected ? 'var(--first)' : '#b3b3b3'};
  width: 28px;
  height: 28px;
  min-width: 28px;
  min-height: 28px;
  border-radius: 50%;
  margin-right: .3em;
  @media screen and (max-width:1450px) {
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
  }
`

const GridItemName = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  font-size: 1.1em;
  font-family: 'imlbold'; font-weight: bold;
  color: ${props => props.$selected ? 'var(--first)' : '#b3b3b3'};
  @media screen and (max-width:1750px) {
    font-size: 1em;
  }
`

const LineSpacing = styled.div`
  border-bottom: ${props => props.$selected ? '2px solid var(--first)' : '2px solid#b3b3b3'};
  flex-grow: 1;
  margin: 0px .5em;
`

const Stepper = props => {
  return (
    <Body>
      <Line />
      <Box mt={{ xs: 3, md: 0 }}>
        <Grid container justify='center'>
          <GridItem item onClick={event => props.onChange(1)} $selected={props.currentStep === 1} xs={4} md>
            <GridItemName $selected={props.currentStep === 1}>
              <Number $selected={props.currentStep === 1}>1</Number>
              Agenda tu cita
            </GridItemName>
            <LineSpacing />
          </GridItem>
          <GridItem item onClick={event => props.onChange(2)} $selected={props.currentStep === 2} xs={4} md>
            <GridItemName $selected={props.currentStep === 2}>
              <Number $selected={props.currentStep === 2}>2</Number>
              Captura tus datos
            </GridItemName>
            <LineSpacing $selected={props.currentStep === 2} />
          </GridItem>
          <GridItem item onClick={event => props.onChange(3)} $selected={props.currentStep === 3} xs={4} md>
            <GridItemName $selected={props.currentStep === 3}>
              <Number $selected={props.currentStep === 3}>3</Number>
              Contesta el estudio <br />
              Epidemiológico
            </GridItemName>
            <LineSpacing $selected={props.currentStep === 3} />
          </GridItem>
          <GridItem item onClick={event => props.onChange(4)} $selected={props.currentStep === 4} xs={4} md>
            <GridItemName $selected={props.currentStep === 4}>
              <Number $selected={props.currentStep === 4}>4</Number>
              Realiza tu pago
            </GridItemName>
            <LineSpacing $selected={props.currentStep === 4} />
          </GridItem>
          <GridItem item onClick={event => props.onChange(5)} $selected={props.currentStep === 5}>
            <GridItemName $selected={props.currentStep === 5}>
              <Number $selected={props.currentStep === 5}>5</Number>
              Envía tu IFE/INE <br />
              y comprobante
            </GridItemName>
            <LineSpacing $selected={props.currentStep === 5} />
          </GridItem>
        </Grid>
      </Box>
    </Body>
  )
}

Stepper.propTypes = {
  currentStep: number,
  onChange: func
}

export default Stepper
